
/*
 * CONSTANT
 *
 * Helper function to decorate constants and make them standardized.
 */
export function constant(items) {
  if (!('ALL' in items)) {
    throw 'Must include ALL in constants.  Constant: ' + items;
  }

  // Set the ALL constant
  let all = {};
  Object.keys(items).forEach(key => {
    if (key !== 'ALL') {
      items.ALL[key] = key;
    }
  });
  items.ALL = all;

  return items;
}

export const PRODUCT_NAME = "Theatre Manager Server";

export const CONNECT_META_POSTFIX = "Meta";

export const DEFAULT_API_FILTER_NAME = "default";

export const DIRECTOR_CHANNEL_PREFIX = "director";
export const DIRECTOR_CHANNEL_DELIMITTER= "::";

export const LOGIN_ROUTE = '/login';